import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';
import type { TOrder } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class OrdersService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): Observable<TOrder[]> {
        const path = this.firestorePathsService.getOrdersPath();
        const observable = this.firestoreService.getObservable(path);
        return observable as Observable<TOrder[]>;
    }

    public async getByUid(uid: string): Promise<TOrder> {
        const path = this.firestorePathsService.getOrdersPath();
        return this.firestoreService.getByUid(path, uid) as Promise<TOrder>;
    }

    public async getAll(): Promise<TOrder[]> {
        const path = this.firestorePathsService.getOrdersPath();
        return this.firestoreService.getAll(path) as Promise<TOrder[]>;
    }

    public async set(doc: TOrder, uid = ''): Promise<TOrder> {
        if (uid) {
            doc.uid = uid;
        }
        const collection = this.firestorePathsService.getOrdersPath();
        return this.firestoreService.set(collection, doc) as Promise<TOrder>;
    }

    public async delete(uid: string): Promise<void> {
        const collection = this.firestorePathsService.getOrdersPath();
        return this.firestoreService.delete(collection, uid);
    }

    public sort(orders: TOrder[], sortAscending = true): TOrder[] {
        const sortedOrders = orders.sort((a, b) => {
            const aOrderId = a?.header?.orderId;
            const bOrderId = b?.header?.orderId;

            if (!aOrderId || !bOrderId) {
                return 0;
            }

            // This is a reverse sort
            if (aOrderId < bOrderId) {
                // return -1;
                return (sortAscending ? -1 : 1);
            } else if (aOrderId > bOrderId) {
                // return 1;
                return (sortAscending ? 1 : -1);
            } else {
                return 0;
            }
        });
        return sortedOrders;
    }
}

/*
        const sortedOrders = orders.sort((a, b) => {
            const aOrderId = a?.header?.orderId;
            const bOrderId = b?.header?.orderId;

            if (!aOrderId || !bOrderId) {
                return null;
            }

            // This is a reverse sort
            if (aOrderId < bOrderId) {
                // return -1;
                return (sortAscending ? -1 : 1);
            } else if (aOrderId > bOrderId) {
                // return 1;
                return (sortAscending ? 1 : -1);
            } else {
                return 0;
            }
        });
        return sortedOrders;

*/
